const mockEvents = {
  city: {
    id: 3101,
    city: 'Manchester',
    lat: 42.99,
    lon: -71.47,
    state: 'NH',
    country: 'us',
    zip: '03101',
    member_count: 4132,
  },
  events: [
    {
      created: 1577648966000,
      duration: 14400000,
      id: '267496593',
      name: 'PEMIGEWASSET NORTH WOODSTOCK SECTION',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1588429800000,
      local_date: '2020-05-02',
      local_time: '10:30',
      updated: 1577648966000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 5,
      group: {
        created: 1386861730000,
        name: 'NH AMC Paddlers',
        id: 11433262,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'NH-AMC-Paddlers',
        who: 'Paddlers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/NH-AMC-Paddlers/events/267496593/',
      description: '<p>Pemigewasset at North Woodstock is a class 2 river with class 2 rapids and wave trains. There is a class 3 rapid at the end that can be run or not. You can register at<br/><a href="https://activities.outdoors.org/search/index.cfm/action/details/id/117356" class="linkified">https://activities.outdoors.org/search/index.cfm/action/details/id/117356</a><br/>or call me at<br/>[masked]</p> ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1578527652000,
      duration: 741600000,
      fee: {
        accepts: 'cash',
        amount: 110,
        currency: 'USD',
        description: '',
        label: 'Price',
        required: false,
      },
      id: '267761781',
      name: 'BONAVENTURE RIVER',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1590922800000,
      local_date: '2020-05-31',
      local_time: '07:00',
      updated: 1578527706000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      group: {
        created: 1386861730000,
        name: 'NH AMC Paddlers',
        id: 11433262,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'NH-AMC-Paddlers',
        who: 'Paddlers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/NH-AMC-Paddlers/events/267761781/',
      description: '<p>We will drive to Bonaventure Quebec from there we will be shuttle a 100 KM(79 mi) to Bonaventure Lake. The river is clears and cold with class I and II rapids and some class 3 ledges no portages some lining may be require. Shuttle fee is around 110 dollars Canadian each provided we have 8 people. You will need white water skills this is in the wilderness. You will also need a passport or pass card. a Deposit will be required by May 1 to reserve your spot<br/>You Must Register through Outdoors<br/><a href="https://activities.outdoors.org/search/index.cfm/action/details/id/117513" class="linkified">https://activities.outdoors.org/search/index.cfm/action/details/id/117513</a></p> ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1550426299000,
      duration: 7200000,
      id: 'zjqxrqybcfbhb',
      name: 'Fun & easy way to play more tennis (please read event description for details)',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1583452800000,
      local_date: '2020-03-05',
      local_time: '19:00',
      updated: 1550426299000,
      utc_offset: -18000000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      group: {
        created: 1530026483000,
        name: 'PlayYourCourt Manchester Tennis',
        id: 28992355,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'PlayYourCourt-Manchester-Tennis',
        who: 'Members',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/PlayYourCourt-Manchester-Tennis/events/zjqxrqybcfbhb/',
      description: '<p>We’re still working to get more people into these Meetups, but our goal is to give PlayYourCourt members a few social tennis outings each week in addition to your practice sessions and Challenge League matches.</p> <p>These Meetups are co-ed, super laid back, and all skill levels are welcome. Post your skill level and a suggested court in the comments section so we can round up as many players as we can for some tennis fun!</p> <p>Also, if you’re looking to meet new practice partners or play some matches and you aren’t already in the PlayYourCourt Community, you can go here to see what we’re all about and sign up:</p> <p><a href="https://www.playyourcourt.com/tennis-community/manchester-nh/meetup/" class="linkified">https://www.playyourcourt.com/tennis-community/manchester-nh/meetup/</a></p> <p>If you love tennis, we’d love to have you! Be sure and watch the quick video that explains how everything works.</p> <p>Happy hitting!</p> <p>- Scott</p> ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      local_time: '18:30',
      local_date: '2020-03-10',
      link: 'https://www.meetup.com/20sand30sHangingOut/events/qrcqnrybcfbnb/',
      visibility: 'public_limited',
      group: {
        created: 1354988361000,
        name: '20\'s & 30\'s Hanging Out',
        id: 6163432,
        join_mode: 'approval',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: '20sand30sHangingOut',
        who: '20\'s & 30\'s Socializers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 3,
      duration: 10800000,
      time: 1583879400000,
      utc_offset: -14400000,
      name: 'Movie Night Tuesday - Knives Out',
      id: 'qrcqnrybcfbnb',
    },
    {
      local_time: '19:00',
      local_date: '2020-03-13',
      link: 'https://www.meetup.com/20sand30sHangingOut/events/268991469/',
      visibility: 'public_limited',
      group: {
        created: 1354988361000,
        name: '20\'s & 30\'s Hanging Out',
        id: 6163432,
        join_mode: 'approval',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: '20sand30sHangingOut',
        who: '20\'s & 30\'s Socializers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 8,
      duration: 7200000,
      time: 1584140400000,
      utc_offset: -14400000,
      name: 'Meet and Greet 🤠 Western Themed ',
      id: '268991469',
    },
    {
      created: 1581265631000,
      duration: 7200000,
      id: 'xwpvnrybchbdb',
      name: 'Introduction to Real Estate Investing',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1588435200000,
      local_date: '2020-05-02',
      local_time: '12:00',
      rsvp_close_offset: 'PT24H',
      updated: 1581266494000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 26817830,
        name: 'The Farm Bar and Grille',
        lat: 42.99507141113281,
        lon: -71.46300506591797,
        repinned: true,
        address_1: '1181 Elm Street',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        phone: '603-641-3276',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1579103798000,
        name: 'Manchester Beginner Real Estate Investing Meetup Group',
        id: 33206838,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Manchester-Beginner-Real-Estate-Investing-Meetup-Group',
        who: 'Future Moguls',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Manchester-Beginner-Real-Estate-Investing-Meetup-Group/events/xwpvnrybchbdb/',
      description: '<p>During this class, we will explore Chapter 4, creating your business plan.<br/>We will survey the first 3 chapters and your niche/strategies and talk about how to get where you are going.</p> <p>This is the introduction to real estate investing curriculum. It is an instructor led course through the materials and is a survey of property types, financing options, entity vs personal title, insurance, etc.</p> <p>The topics to be covered vary every week as do the presenters. This is not meant to be a networking event although it can be. It is meant to be instruction/discussion for those beginning in real estate investing only.</p> <p>This is best for investors who have not done an investment up to those who have done their first three. During your first attendance, you will receive your textbook and workbook binder. You will bring that with you to each class.</p> <p>Looking forward to sharing! Please reply as soon as possible if you will be attending. Drinks (tea, soft drinks, etc.) are covered as is a starting round of their delicious chicken wings! You may also order individually.</p> ',
      how_to_find_us: 'We will be at a table in the dining room on the left.  ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1582557851000,
      duration: 6300000,
      id: '268951851',
      name: 'March into Spring:  Creating a Custom Login Page + Open Forum',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1583964900000,
      local_date: '2020-03-11',
      local_time: '18:15',
      updated: 1582644208000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 11,
      venue: {
        id: 25727627,
        name: 'Schall Creative, LLC',
        lat: 42.98920440673828,
        lon: -71.46875762939453,
        repinned: true,
        address_1: 'Suite 2023, 250 North Commercial St, ',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        phone: '603 782 3322',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1247505142000,
        name: 'New Hampshire WordPress',
        id: 1488811,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'WordPressDevNH',
        who: 'WordPress fans',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/WordPressDevNH/events/268951851/',
      description: '<p>6:15 Doors open for mixing, mingling, and refreshments</p> <p>6:30 Welcome and introductions</p> <p>6:45 Featured Topic Discussion: Creating A Custom Login Page</p> <p>We will look at the what, why, and, how of creating a custom login page for your website. Continue your site\'s branding and style right to the login page for your users and customers. If you are using an online store like WooCommerce or have a membership site where people will be logging into your site then this will help create a better and more seamless user experience.</p> <p>We will show you a few different ways to create custom login pages, everything from a simple plugin to page editor to custom coding. All are doable and not that difficult.</p> <p>Our Presenter: David Heckel is the Managing Partner of Culver Technologies, an IT Managed Services company providing outsourced IT services, web development, and internet marketing to small and mid-sized businesses.</p> <p>7:30 Open Forum<br/>All questions welcome! This is your chance to pick the brains of your fellow WordPress enthusiasts!</p> <p>7:50 Wrap Up</p> ',
      visibility: 'public',
      pro_is_email_shared: false,
      member_pay_fee: false,
    },
    {
      local_time: '18:30',
      local_date: '2020-03-11',
      link: 'https://www.meetup.com/gaymennhmass/events/269155782/',
      visibility: 'public_limited',
      group: {
        created: 1439397803000,
        name: 'Gay Men of NH, Mass and Beyond',
        id: 18826687,
        join_mode: 'approval',
        lat: 42.97999954223633,
        lon: -71.51000213623047,
        urlname: 'gaymennhmass',
        who: 'Members',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 5,
      duration: 7200000,
      time: 1583965800000,
      utc_offset: -14400000,
      name: 'MONTHLY Doogie\'s Social (Dinner available)',
      id: '269155782',
    },
    {
      local_time: '18:30',
      local_date: '2020-03-25',
      link: 'https://www.meetup.com/20sand30sHangingOut/events/qrcqnrybcfbgc/',
      visibility: 'public_limited',
      group: {
        created: 1354988361000,
        name: '20\'s & 30\'s Hanging Out',
        id: 6163432,
        join_mode: 'approval',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: '20sand30sHangingOut',
        who: '20\'s & 30\'s Socializers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 2,
      duration: 10800000,
      time: 1585175400000,
      utc_offset: -14400000,
      name: 'Movie Night Wednesday - Horror night "Candyman"',
      id: 'qrcqnrybcfbgc',
    },
    {
      created: 1582678725000,
      duration: 7200000,
      fee: {
        accepts: 'cash',
        amount: 20,
        currency: 'USD',
        description: '',
        label: 'Price',
        required: false,
      },
      id: '268992455',
      name: 'Monthly Keto Club',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585000800000,
      local_date: '2020-03-23',
      local_time: '18:00',
      updated: 1582678725000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 26296919,
        name: 'Gauchos Churrascaria Brazilian Steakhouse & Butchery',
        lat: 42.99382019042969,
        lon: -71.46124267578125,
        repinned: true,
        address_1: '62 Lowell St',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1582128974000,
        name: 'Manchester Keto Club',
        id: 33385995,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Manchester-Keto-Club',
        who: 'Members',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Manchester-Keto-Club/events/268992455/',
      description: '<p>Monthly meetup at our host location Gauchos! They have the BEST keto options!! We meet for 90 minutes... your ticket includes food, networking, keto samples and an info session! Super casual!!</p> <p>Please rsvp for headcount!! You can secure your spot with a ticket through this link: <a href="https://www.eventbrite.com/e/march-manchester-keto-club-tickets-96796877065" class="linkified">https://www.eventbrite.com/e/march-manchester-keto-club-tickets-96796877065</a></p> ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1582644698000,
      duration: 6300000,
      id: '268978919',
      name: 'April 2020 NH WordPress Meetup - Featured Topic TBD',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586384100000,
      local_date: '2020-04-08',
      local_time: '18:15',
      updated: 1582644698000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 3,
      venue: {
        id: 25727627,
        name: 'Schall Creative, LLC',
        lat: 42.98920440673828,
        lon: -71.46875762939453,
        repinned: true,
        address_1: 'Suite 2023, 250 North Commercial St, ',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        phone: '603 782 3322',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1247505142000,
        name: 'New Hampshire WordPress',
        id: 1488811,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'WordPressDevNH',
        who: 'WordPress fans',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/WordPressDevNH/events/268978919/',
      description: '<p>6:15 Doors open for mixing, mingling, and refreshments</p> <p>6:30 Welcome and introductions</p> <p>6:45 Featured Topic Discussion: TBD</p> <p>7:30 Open Forum</p> <p>All questions welcome! This is your chance to pick the brains of your fellow WordPress enthusiasts!</p> <p>7:50 Wrap Up</p> ',
      visibility: 'public',
      pro_is_email_shared: false,
      member_pay_fee: false,
    },
    {
      created: 1583075710000,
      duration: 7200000,
      id: '269107162',
      name: 'Let\'s attend Manchester\'s Urban Ponds: Past, Present & Future ',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586899800000,
      local_date: '2020-04-14',
      local_time: '17:30',
      updated: 1583081746000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 4,
      venue: {
        id: 26208610,
        name: 'Manchester Historic Association Millyard Museum',
        lat: 42.98960494995117,
        lon: -71.46808624267578,
        repinned: true,
        address_1: '200 Bedford St',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1582076279000,
        name: 'History and Culture Explorers',
        id: 33381458,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Manchester-Historic-Buildings-Meetup-Group',
        who: 'Historians',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Manchester-Historic-Buildings-Meetup-Group/events/269107162/',
      description: '<p>Although ponds may not be the first thing one thinks about in Manchester, the Queen City has several ponds that have played an important role in the area’s history. More recently, the Manchester Urban Ponds Restoration Program, established in 2000, has led cleanup efforts to help return the city’s ponds to their historic uses. This exhibit looks at the history of several of Manchester’s urban ponds, including Crystal Lake, Dorrs Pond, Maxwell Pond, Nutts Pond, Pine Island Pond, and Stevens Pond and celebrates the accomplishments of the Urban Ponds Restoration Program over the last 20 years.<br/>Just bring yourself, your interest in the topic, and entrance fee if applicable!<br/>This is an RSVP event, so I would need a head count a couple days prior. We could find a coffee shop afterwards (I\'ll do some research) to debrief afterwards if everyone is game. I suggest meeting in the lobby area 15 minutes prior to the event so we can enter together if possible. *Keep an eye out for more details or DM me*</p> ',
      how_to_find_us: 'Meet me in the lobby approx 15 minutes prior to the start time!',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      local_time: '11:30',
      local_date: '2020-03-12',
      link: 'https://www.meetup.com/Lets-Have-a-NetLunch/events/269097979/',
      visibility: 'public_limited',
      group: {
        created: 1329968326000,
        name: 'NetLunch! - Where women connect!',
        id: 3348132,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Lets-Have-a-NetLunch',
        who: 'Members',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 3,
      duration: 7200000,
      time: 1584027000000,
      utc_offset: -14400000,
      name: 'NetLunch!  10th Anniversary - MANCHESTER - MARCH',
      id: '269097979',
    },
    {
      created: 1577647896000,
      duration: 14400000,
      id: '267496352',
      name: 'CROYDEN BROOK',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586613600000,
      local_date: '2020-04-11',
      local_time: '10:00',
      updated: 1577647942000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 6,
      group: {
        created: 1386861730000,
        name: 'NH AMC Paddlers',
        id: 11433262,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'NH-AMC-Paddlers',
        who: 'Paddlers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/NH-AMC-Paddlers/events/267496352/',
      description: '<p>Intense class 2 river with a class 3 drop<br/>Cold Water Gear and Class 2 white skills require to do this trip<br/>You need to register for this trip you can register at<br/><a href="https://activities.outdoors.org/search/index.cfm/action/details/id/116205" class="linkified">https://activities.outdoors.org/search/index.cfm/action/details/id/116205</a><br/>or call me at<br/>My phone number is[masked]</p> ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1580315037000,
      duration: 7200000,
      id: 'lsmmnrybcfbkb',
      name: 'Introduction to Real Estate Investing',
      rsvp_limit: 15,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1583600400000,
      local_date: '2020-03-07',
      local_time: '12:00',
      rsvp_close_offset: 'PT24H',
      updated: 1582941136000,
      utc_offset: -18000000,
      waitlist_count: 0,
      yes_rsvp_count: 15,
      venue: {
        id: 26817830,
        name: 'The Farm Bar and Grille',
        lat: 42.99507141113281,
        lon: -71.46300506591797,
        repinned: true,
        address_1: '1181 Elm Street',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        phone: '603-641-3276',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1579103798000,
        name: 'Manchester Beginner Real Estate Investing Meetup Group',
        id: 33206838,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Manchester-Beginner-Real-Estate-Investing-Meetup-Group',
        who: 'Future Moguls',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Manchester-Beginner-Real-Estate-Investing-Meetup-Group/events/lsmmnrybcfbkb/',
      description: '<p>During this session, we will be exploring Chapter II - Learning About Real Estate Investing where we will explore the types of investing in detail, types of properties, types of financing, and some ways for you to develop your knowledge through self-study and even college courses.</p> <p>This is the introduction to real estate investing curriculum. It is an instructor led course through the materials and is a survey of property types, financing options, entity vs personal title, insurance, etc.</p> <p>The topics to be covered vary every week as do the presenters. This is not meant to be a networking event although it can be. It is meant to be instruction/discussion for those beginning in real estate investing only.</p> <p>This is best for investors who have not done an investment up to those who have done their first three. During your first attendance, you will receive your textbook and workbook binder. You will bring that with you to each class.</p> <p>Looking forward to sharing! Please reply as soon as possible if you will be attending. Drinks (tea, soft drinks, etc.) are covered as is a starting round of their delicious chicken wings! You may also order individually.</p> ',
      how_to_find_us: 'We will be at a table in the dining room on the left.  ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1581265631000,
      duration: 7200000,
      id: 'xwpvnrybcgbgb',
      name: 'Introduction to Real Estate Investing',
      rsvp_limit: 10,
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1586016000000,
      local_date: '2020-04-04',
      local_time: '12:00',
      rsvp_close_offset: 'PT24H',
      updated: 1581266150000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 2,
      venue: {
        id: 26817830,
        name: 'The Farm Bar and Grille',
        lat: 42.99507141113281,
        lon: -71.46300506591797,
        repinned: true,
        address_1: '1181 Elm Street',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        phone: '603-641-3276',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1579103798000,
        name: 'Manchester Beginner Real Estate Investing Meetup Group',
        id: 33206838,
        join_mode: 'open',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Manchester-Beginner-Real-Estate-Investing-Meetup-Group',
        who: 'Future Moguls',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Manchester-Beginner-Real-Estate-Investing-Meetup-Group/events/xwpvnrybcgbgb/',
      description: '<p>This session we explore Chapter 3 - discussing niches in real estate investing and the various strategies you might use to make money. This course helps you focus to get ready for next month where you will learn to create your business plan.</p> <p>This is the introduction to real estate investing curriculum. It is an instructor led course through the materials and is a survey of property types, financing options, entity vs personal title, insurance, etc.</p> <p>The topics to be covered vary every week as do the presenters. This is not meant to be a networking event although it can be. It is meant to be instruction/discussion for those beginning in real estate investing only.</p> <p>This is best for investors who have not done an investment up to those who have done their first three. During your first attendance, you will receive your textbook and workbook binder. You will bring that with you to each class.</p> <p>Looking forward to sharing! Please reply as soon as possible if you will be attending. Drinks (tea, soft drinks, etc.) are covered as is a starting round of their delicious chicken wings! You may also order individually.</p> ',
      how_to_find_us: 'We will be at a table in the dining room on the left.  ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      created: 1580920387000,
      duration: 7200000,
      id: '268480470',
      name: 'Monthly Book Club',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1583452800000,
      local_date: '2020-03-05',
      local_time: '19:00',
      updated: 1580920961000,
      utc_offset: -18000000,
      waitlist_count: 0,
      yes_rsvp_count: 5,
      venue: {
        id: 26057400,
        name: 'Bookery Manchester',
        lat: 42.990150451660156,
        lon: -71.46321868896484,
        repinned: true,
        address_1: '844 Elm St',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1560124098000,
        name: 'Awakened Woman Book Club',
        id: 32137941,
        join_mode: 'approval',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Awakened-Woman-Book-Club',
        who: 'Booklovers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Awakened-Woman-Book-Club/events/268480470/',
      description: '<p>We will discuss the book, “Girl, Woman, Other” by Bernardine Evaristo.</p> <p>NATIONAL BESTSELLER<br/>WINNER OF THE BOOKER PRIZE</p> <p>“A must-read about modern Britain and womanhood . . . An impressive, fierce novel about the lives of black British families, their struggles, pains, laughter, longings and loves . . . Her style is passionate, razor-sharp, brimming with energy and humor. There is never a single moment of dullness in this book and the pace does not allow you to turn away from its momentum.”―Booker Prize Judges</p> <p>Bernardine Evaristo is the winner of the 2019 Booker Prize and the first black woman to receive this highest literary honor in the English language. Girl, Woman, Other is a magnificent portrayal of the intersections of identity and a moving and hopeful story of an interconnected group of Black British women that paints a vivid portrait of the state of contemporary Britain and looks back to the legacy of Britain’s colonial history in Africa and the Caribbean.</p> <p>The twelve central characters of this multi-voiced novel lead vastly different lives: Amma is a newly acclaimed playwright whose work often explores her Black lesbian identity; her old friend Shirley is a teacher, jaded after decades of work in London’s funding-deprived schools; Carole, one of Shirley’s former students, is a successful investment banker; Carole’s mother Bummi works as a cleaner and worries about her daughter’s lack of rootedness despite her obvious achievements. From a nonbinary social media influencer to a 93-year-old woman living on a farm in Northern England, these unforgettable characters also intersect in shared aspects of their identities, from age to race to sexuality to class.</p> <p>Sparklingly witty and filled with emotion, centering voices we often see othered, and written in an innovative fast-moving form that borrows technique from poetry, Girl, Woman, Other is a polyphonic and richly textured social novel that shows a side of Britain we rarely see, one that reminds us of all that connects us to our neighbors, even in times when we are encouraged to be split apart.</p> <p>About the Author</p> <p>Anglo-Nigerian writer Bernardine Evaristo is the celebrated author of eight books and the winner of the 2019 Booker Prize. Her writing is characterized by experimentation, daring, subversion, and challenging the myths of various Afro-diasporic histories and identities, and her books range in genre from poetry to short story to drama to criticism. She lives in London.</p> <p><a href="https://www.amazon.com/dp/0802156983/ref=cm_sw_em_r_mt_dp_U_v3UoEbTTHN6WD" class="linkified">https://www.amazon.com/dp/0802156983/ref=cm_sw_em_r_mt_dp_U_v3UoEbTTHN6WD</a></p> <p>***NOTE: I do not make any money from the sale of books by Amazon. The link is purely for your convenience.</p> ',
      how_to_find_us: 'We will be in the meeting room or just outside of it. ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      local_time: '13:00',
      local_date: '2020-03-15',
      link: 'https://www.meetup.com/The-Middle-Ages-Active-ladies-in-the-603/events/267251451/',
      visibility: 'public_limited',
      group: {
        created: 1500985551000,
        name: 'Ladies of the (603) - Social Group 50-60--',
        id: 25128983,
        join_mode: 'approval',
        lat: 42.970001220703125,
        lon: -71.44000244140625,
        urlname: 'The-Middle-Ages-Active-ladies-in-the-603',
        who: 'Lovely (603) Ladies',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 11,
      duration: 7200000,
      time: 1584291600000,
      utc_offset: -14400000,
      name: 'Around the world wine party',
      id: '267251451',
    },
    {
      created: 1580921201000,
      duration: 7200000,
      id: '268480951',
      name: 'Monthly Book Club',
      date_in_series_pattern: false,
      status: 'upcoming',
      time: 1585868400000,
      local_date: '2020-04-02',
      local_time: '19:00',
      updated: 1580921201000,
      utc_offset: -14400000,
      waitlist_count: 0,
      yes_rsvp_count: 1,
      venue: {
        id: 26057400,
        name: 'Bookery Manchester',
        lat: 42.990150451660156,
        lon: -71.46321868896484,
        repinned: true,
        address_1: '844 Elm St',
        city: 'Manchester',
        country: 'us',
        localized_country_name: 'USA',
        zip: '03101',
        state: 'NH',
      },
      group: {
        created: 1560124098000,
        name: 'Awakened Woman Book Club',
        id: 32137941,
        join_mode: 'approval',
        lat: 42.9900016784668,
        lon: -71.47000122070312,
        urlname: 'Awakened-Woman-Book-Club',
        who: 'Booklovers',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      link: 'https://www.meetup.com/Awakened-Woman-Book-Club/events/268480951/',
      description: '<p>We will discuss the book, “American Dirt” by Jeanine Cummins.</p> <p>#1 New York Times Bestseller<br/>OPRAH’S BOOK CLUB PICK</p> <p>“Extraordinary.”<br/>―Stephen King</p> <p>“This book is not simply the great American novel; it’s the great novel of las Americas. It’s the great world novel! This is the international story of our times. Masterful.”<br/>―Sandra Cisneros</p> <p>También de este lado hay sueños. On this side, too, there are dreams.</p> <p>Lydia Quixano Pérez lives in the Mexican city of Acapulco. She runs a bookstore. She has a son, Luca, the love of her life, and a wonderful husband who is a journalist. And while there are cracks beginning to show in Acapulco because of the drug cartels, her life is, by and large, fairly comfortable.</p> <p>Even though she knows they’ll never sell, Lydia stocks some of her all-time favorite books in her store. And then one day a man enters the shop to browse and comes up to the register with a few books he would like to buy―two of them her favorites. Javier is erudite. He is charming. And, unbeknownst to Lydia, he is the jefe of the newest drug cartel that has gruesomely taken over the city. When Lydia’s husband’s tell-all profile of Javier is published, none of their lives will ever be the same.</p> <p>Forced to flee, Lydia and eight-year-old Luca soon find themselves miles and worlds away from their comfortable middle-class existence. Instantly transformed into migrants, Lydia and Luca ride la bestia―trains that make their way north toward the United States, which is the only place Javier’s reach doesn’t extend. As they join the countless people trying to reach el norte, Lydia soon sees that everyone is running from something. But what exactly are they running to?</p> <p>American Dirt will leave readers utterly changed. It is a literary achievement filled with poignancy, drama, and humanity on every page. It is one of the most important books for our times.</p> <p>Already being hailed as "a Grapes of Wrath for our times" and "a new American classic," Jeanine Cummins\'s American Dirt is a rare exploration into the inner hearts of people willing to sacrifice everything for a glimmer of hope.</p> <p>About the Author</p> <p>Jeanine Cummins is the author of four books: the bestselling memoir A Rip in Heaven, and the novels The Outside Boy, The Crooked Branch, and American Dirt. She lives in New York with her husband and two children.</p> <p><a href="https://www.amazon.com/dp/1250209765/ref=cm_sw_em_r_mt_dp_U_g6UoEb5SCKDRS" class="linkified">https://www.amazon.com/dp/1250209765/ref=cm_sw_em_r_mt_dp_U_g6UoEb5SCKDRS</a></p> <p>***NOTE: I do not make any money from the sale of books by Amazon. The link is purely for your convenience.</p> ',
      how_to_find_us: 'We will be in the meeting room or just outside of it. ',
      visibility: 'public',
      member_pay_fee: false,
    },
    {
      local_time: '11:00',
      local_date: '2020-03-29',
      link: 'https://www.meetup.com/The-Middle-Ages-Active-ladies-in-the-603/events/269084016/',
      visibility: 'public_limited',
      group: {
        created: 1500985551000,
        name: 'Ladies of the (603) - Social Group 50-60--',
        id: 25128983,
        join_mode: 'approval',
        lat: 42.970001220703125,
        lon: -71.44000244140625,
        urlname: 'The-Middle-Ages-Active-ladies-in-the-603',
        who: 'Lovely (603) Ladies',
        localized_location: 'Manchester, NH',
        state: 'NH',
        country: 'us',
        region: 'en_US',
        timezone: 'US/Eastern',
      },
      waitlist_count: 0,
      yes_rsvp_count: 7,
      duration: 10800000,
      time: 1585494000000,
      utc_offset: -14400000,
      name: 'Shamrock Shuffle 2 mile run/walk',
      id: '269084016',
    },
  ],
};

export { mockEvents };